import React from "react";
import {
  CartesianGrid,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  XAxis,
  YAxis,
  Tooltip,
  Line,
  LineChart,
} from "recharts";
import styless from "@/page-components/cost-explorer/cost.explorer.module.css";
import { CustomTooltip } from "./customtooltip.part";

export const LineChartPArt = ({ service, data,name }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        // data={data?.data}
        data={data?.data?.length ? data.data : [{ idle_days: ""}]}
        margin={{ top: 0, right: 0, left: 25, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="0" stroke="#F0F0F0" vertical={false} />
        <Tooltip content={CustomTooltip} cursor={{ fill: "transparent" }} />
        <XAxis
         label={{ 
          value: `${name === "snap"?"Creation Date":"Idle Days"}`,
          fill: "#495057",
          fontSize: 10,
          textAnchor: "middle",
          fontWeight: 400,
          position: "insideBottom", 
          dy: 10 
        }}
          dataKey="idle_days"
          tickLine={false}
          axisLine={true}
          fontSize={10}
          fontWeight={400}
          stroke="#495057"
          minTickGap={5}
          fontFamily="Roboto"
        />
        <YAxis
          label={{ 
            value:`${name==="snap"?"Snapshots Count":"Resource Count"}`,fill:"#495057",angle: -90, fontSize: 10,textAnchor: "middle",fontWeight:400,
            position: "insideLeft",dy: 50,dx:-20  }}
          tickLine={false}
          axisLine={true}
          fontSize={10}
          fontWeight={400}
          stroke="#495057"
        />
        {service === "aws" && (
          <>
            <Line
              type="monotone"
              dataKey="cost"
              stroke="#056EE5"
              stackId="a"
            />
          </>
        )}
        {service === "azure" && (
          <>
            <Line
              type="monotone"
              dataKey="cost"
              stroke="#056EE5"
              stackId="a"
            />
          </>
        )}
        {service === "gcp" && (
          <>
            <Line
              type="monotone"
              dataKey="cost"
              stroke="#056EE5"
              stackId="a"
            />
          </>
        )}
      </LineChart>
    </ResponsiveContainer>
  );
};
